/**
 * @desc undefined
 */
import { PricingMethodEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPricingMethodParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/pricingMethod'

export const queryPricingMethodApi = (
  params?: QueryPricingMethodParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PricingMethodEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryPricingMethodApi.method = method
queryPricingMethodApi.url = url
